import { useEffect, useReducer, useState } from "react";
import { useLocation } from "react-router-dom";
import { llmAgentInstruction } from "services/llm";
import { getLLMAgentInstructPayload } from "services/llm/payloads";
import { extractJSONFromText } from "utils/function";
import { getFullDateAndTimeFormatted, getFormattedHistory } from "utils/llm";

const initialArgs = {
    newFeteDetails: {},
    draftEventTasks: [],
    draftEvent: {},
};

const reducer = (state: any, action: any) => {
  return { ...state, ...action };
};

const useNewFete = () => {
  const [state, setState] = useReducer(reducer, initialArgs);
  const location = useLocation();
  
  const resetStateToDefaults = () => {
    setState({ ...initialArgs })
  }

  useEffect(() => {
    resetStateToDefaults();
  }, [location.pathname]);

  const extractFeteOverviewDetails = async ({
    input_variables
  }: any) => {
    let newFeteDetails;
    const res = await llmAgentInstruction(getLLMAgentInstructPayload({
      input_variables
    }))
    if(res && res?.data && res?.data?.text){
      newFeteDetails = extractJSONFromText(res?.data?.text)
    } 
    return newFeteDetails
  }  

  return {
    setState,
    extractFeteOverviewDetails,
    ...state,
  };
};

export default useNewFete;
